<!--
  * name: AppHeader
  * description: Header 컴포넌트
-->
<template>
  <header class="header" :class="headerClasses">
    <util-menus
      :show-mobile-menu="showMobileMenu"
      @toggle-mobile-menu="toggleMobileMenu"
      @toggle-srch="toogleSearch"
      :isSrchOpen='isSrchOpen'
    />
    <srch :isSrchOpen="isSrchOpen" @close-box="closeSearchBox"/>
    <navigation
      :show-mobile-menu="showMobileMenu"
      @toggle-mobile-menu="toggleMobileMenu"
      @openBpPopup="openBpPopup"
    /> <!-- 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 이벤트 추가 -->
  </header>
</template>

<script>
import UtilMenus from './partial/UtilMenus.vue';
import Navigation from './partial/Navigation.vue';
import Srch from './partial/Srch.vue';

export default {
  name: 'AppHeader',
  data() {
    return {
      isSrchOpen: false, /* 서치 영역 오픈 여부 */
      showMobileMenu: false, // 모바일 메뉴 오픈 여부
      isScrollTop: true,
      showNavbar: true,
      lastScrollPosition: 0,
      isScrollDown: false,
      isScrollUp: false,
    };
  },
  components: {
    UtilMenus,
    Navigation,
    Srch,
  },
  computed: {
    isHome() {
      return this.$route.name === 'Home';
    },
    headerClasses() {
      // Header 추가 class
      return {
        // home: this.$route.name === 'Home',
        home: this.isHome && this.isScrollTop,
        scrollUp: this.isScrollUp,
        scrollDown: this.isScrollDown
      };
    },
  },
  watch: {
    showMobileMenu(newValue) {
      if (newValue) {
        document.querySelector('body').classList.add('hide-overflow');
      } else {
        document.querySelector('body').classList.remove('hide-overflow');
      }
    },
    isSrchOpen(val) {
      if (val) {
        document.querySelector('body').classList.add('hide-overflow');
      } else {
        document.querySelector('body').classList.remove('hide-overflow');
      }
    },
  },
  methods: {
    // ## 모바일 메뉴 show/hide 메소드
    toggleMobileMenu(flag) {
      this.showMobileMenu = flag;
    },
    openBpPopup(){ /* 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 추가 */
      this.$emit('openBpPopup', 'bpPopup');
    },
    toogleSearch(flag) {
      this.isSrchOpen = !this.isSrchOpen;
    },
    closeSearchBox() {
      this.isSrchOpen = false;
    },
    onScroll () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      if(this.showNavbar){
        this.isScrollUp = true;
        this.isScrollDown = false;
      } else {
        this.isScrollUp = false;
        this.isScrollDown = true;
      }

      if (currentScrollPosition < 38) {
        this.isScrollTop = true;
        this.isScrollUp = false;
        this.isScrollDown = false;
      } else {
        this.isScrollTop = false;

      }
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    },
    onResize(){ /* pc에서 모바일보기로 네비를 연채로 pc사이즈로 늘리면 스크롤 없어지는 현상 처리 */
      const docWidth = window.clientWidth || document.documentElement.clientWidth;
      if(docWidth > 600){
        this.showMobileMenu = false;
      }else{
        return
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);
  },
};
</script>

<style lang='scss' scoped>
.header.scrollUp .nav .logo-pc {
  background-image: url(/img/logo_riman_navi.svg);
  background-repeat: no-repeat;
}
.header.scrollUp .nav .nav-main a {
    color: #666;
}
.header.scrollUp .nav{
  margin-top: -4.2rem;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.5);
  background-color: white;
  @media (max-width: $mobile-size) {
    margin-top: 0;
  }
}
.header.scrollDown .nav{
  margin-top: -20rem;
  box-shadow: none;
  background-color: white;
}
.header.scrollUp .util-wrap{
  @media (max-width: $mobile-size) {
    margin-top: 0;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.5);
  }
}
.header.scrollDown .util-wrap{
  @media (max-width: $mobile-size) {
    margin-top: -10rem; 
    box-shadow: none;
  }
}
</style>
